
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 26a9.72 9.72 0 01-3.898-.788 10.112 10.112 0 01-3.175-2.14c-.9-.9-1.613-1.958-2.139-3.174A9.721 9.721 0 016 16c0-1.382.263-2.681.788-3.898a10.112 10.112 0 012.14-3.175c.9-.9 1.958-1.613 3.174-2.139A9.721 9.721 0 0116 6c2.507 0 4.686.806 6.536 2.418 1.85 1.612 2.959 3.619 3.324 6.02H24.25a8.347 8.347 0 00-1.727-3.769 8.121 8.121 0 00-3.364-2.479v.442c0 .579-.206 1.074-.619 1.486a2.027 2.027 0 01-1.486.619h-2.106v2.105c0 .298-.1.548-.302.75a1.018 1.018 0 01-.75.303H11.79V16h2.024v3.158h-.972L7.79 14.105c-.052.316-.1.632-.144.948a6.879 6.879 0 00-.066.947c0 2.298.807 4.272 2.421 5.921 1.614 1.65 3.614 2.483 6 2.5V26zm9.538-.405l-3.5-3.48c-.341.218-.709.393-1.103.527a3.87 3.87 0 01-1.25.2c-1.175 0-2.17-.408-2.987-1.225-.816-.816-1.224-1.811-1.224-2.985 0-1.175.408-2.17 1.224-2.986.817-.817 1.812-1.225 2.986-1.225 1.174 0 2.17.408 2.986 1.225.816.816 1.225 1.811 1.225 2.986 0 .446-.069.868-.206 1.266a4.957 4.957 0 01-.541 1.108l3.5 3.48-1.11 1.11zm-5.854-4.332c.737 0 1.36-.254 1.869-.763.508-.509.763-1.132.763-1.868 0-.737-.255-1.36-.763-1.869-.51-.509-1.132-.763-1.869-.763-.737 0-1.36.254-1.868.763-.509.509-.763 1.132-.763 1.869 0 .736.254 1.36.763 1.868.509.509 1.131.763 1.868.763z"}})])
          )
        }
      }
    